<template>
  <resource-box name="回收品类分布">
    <div class="recyLing" slot="content">
      <div v-if="materials.length" class="echarts" id="mains"></div>
      <el-empty
        :image="require('@/assets/recycling/index/empty.svg')"
        description="暂无数据"
        style="height: inherit"
        v-else
      />
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/IndustryMap/components/resourceBox.vue';
import * as echarts from 'echarts';
import { autoToolTip } from '@/util/echarts_auto_tooltip';
export default {
  name: 'dataOverview',
  components: {
    resourceBox,
  },
  props: {
    materials: {
      type: Array,
      default: function () {
        return [];
      },
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    mapData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    mapData: {
      deep: true,
      handler: function (val) {
        let comment = 0;
        if (val) {
          if (val.provinceProduction) {
            this.result = Number(val.provinceProduction).toFixed(0);
          } else {
            this.result = 0;
          }
          if (val.materials) {
            let sortArray = this.processWasteData(val.materials);
            console.log(sortArray, 'sortArraysortArray');
            sortArray.forEach((item) => {
              comment = comment + Number(item.amount);
            });
            this.processMaterials(sortArray, comment.toFixed(0));
          }
        }
      },
      immediate: true,
    },
    materials: {
      handler: function (newVal) {
        if (newVal && newVal.length) {
        }
      },
      deep: true,
    },
    fullscreen: {
      handler: function (newVal) {
        this.Resize();
      },
    },
  },
  data() {
    return {
      AmountOfRecycling: 0,
      Data: [],
      result: 0,
      myChart: '',
      oldWidth: null,
      oldHeight: null,
      Resize: null,
      color: [
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#FF7474', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0, 162, 255, 0)', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#FFBE54', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(94, 73, 235, 0.01)', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#FEF65C', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(64, 255, 140, 0)', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#B2EF39', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0, 234, 255, 0)', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#63DD63', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0, 234, 255, 0)', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: '#CE7DF9', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: '#775DF7', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: '#4D87FD', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: '#48BFFB', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: 'pie',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: '#6AFCFC', // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
      ]
    };
  },
  created() {},
  mounted() {
    // 存储初始容器的宽高
    setTimeout(() => {
      const oldContainer = document.getElementById('mains'); // 替换为你的容器ID
      const { width, height } = oldContainer.getBoundingClientRect();
      this.oldWidth = width;
      this.oldHeight = height;
    }, 500);
    // 2. 强制更新ECharts内部容器和canvas的宽高
    const that = this;
    // 处理尺寸变化的核心函数
    const handleResize = () => {
      if (!that.myChart) return;

      // 1. 获取绑定的DOM容器最新尺寸（已自适应全屏的容器）
      const container = document.getElementById('mains'); // 替换为你的容器ID
      if (!container) return;

      // 2. 强制更新ECharts内部容器和canvas的宽高
      const { width, height } = container.getBoundingClientRect();

      // 3. 获取ECharts内部容器（通常是第一个子元素）并设置尺寸
      const echartsInnerContainer = container.firstChild;
      if (echartsInnerContainer) {
        echartsInnerContainer.style.width = `${width}px`;
        echartsInnerContainer.style.height = `${height}px`;
      }

      // 4. 获取canvas元素并强制设置尺寸（解决canvas绘制尺寸不更新问题）
      const canvas = container.querySelector('canvas');
      if (canvas) {
        // 注意：canvas的width/height属性（绘制尺寸）和style.width/style.height（显示尺寸）需同步
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
      }
      const titlePosition = {
        top: `${(height / that.oldHeight) * 26}%`, // 保持原始设计的垂直比例
        left: `${(width / that.oldWidth) * 43.5}%`, // 保持原始设计的水平比例
      };
      that.myChart.setOption({
        title: {
          top: titlePosition.top,
          left: titlePosition.left,
          // 其他标题配置（字体、边框等）
        },
      });
      // 5. 触发ECharts重绘（确保所有组件重新布局）
      setTimeout(() => {
        that.myChart.resize({
          width: width, // 显式指定新宽度
          height: height, // 显式指定新高度
        });
      }, 100); // 微延迟确保DOM更新后执行
    };

    // 绑定事件监听（覆盖所有可能的尺寸变化场景）
    window.addEventListener('resize', handleResize);
    document.addEventListener('fullscreenchange', handleResize);
    document.addEventListener('webkitfullscreenchange', handleResize);
    document.addEventListener('mozfullscreenchange', handleResize);
    document.addEventListener('msfullscreenchange', handleResize);

    // 组件销毁时清理
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('fullscreenchange', handleResize);
      document.removeEventListener('webkitfullscreenchange', handleResize);
      document.removeEventListener('mozfullscreenchange', handleResize);
      document.removeEventListener('msfullscreenchange', handleResize);
      that.myChart = null;
    });
    this.Resize = handleResize;
  },
  methods: {
    // 新增数据处理方法
    processMaterials(materials, result) {
      let dataArray = [];
      materials.forEach((item) => {
        dataArray.push({
          value: Number(item.amount),
          name: item.name,
          percentage: `${((Number(item.amount) / result) * 100).toFixed(2)}%`,
        });
      });
      this.Data = [
        ...dataArray.filter((item) => item.name !== '其他'), // 所有非“其他”元素
        ...dataArray.filter((item) => item.name === '其他'), // “其他”元素（仅1个）
      ];
      window.pieData = this.Data;
      setTimeout(() => {
        this.initEcharts();
      }, 350);
    },
    initEcharts() {
      let that = this;
      // 1. 获取绑定的DOM容器最新尺寸（已自适应全屏的容器）
      const container = document.getElementById('mains'); // 替换为你的容器ID
      if (!container) return;
      // 2. 强制更新ECharts内部容器和canvas的宽高
      const { width, height } = container.getBoundingClientRect();
      const initTitlePosition = {
        top: this.oldHeight ? `${(height / this.oldHeight) * 26}%` : '26%',
        left: this.oldWidth ? `${(width / this.oldWidth) * 43.5}%` : '43.5%',
      };
      let chartDom = document.getElementById('mains');
      if (!chartDom) return;
      // 字符串截断工具函数：超过maxLength则截断并加省略号
      function truncateText(text, maxLength = 5) {
        if (typeof text !== 'string') return text;
        return text.length > maxLength
          ? text.slice(0, maxLength) + '...'
          : text;
      }
      this.myChart = echarts.init(chartDom);
      let option = {
        color: [
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#FF7474', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(0, 162, 255, 0)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#FFBE54', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(94, 73, 235, 0.01)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#FEF65C', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(64, 255, 140, 0)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#B2EF39', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(0, 234, 255, 0)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#63DD63', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(0, 234, 255, 0)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#CE7DF9', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#775DF7', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#4D87FD', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#48BFFB', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'pie',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(255, 235, 168, 0)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#6AFCFC', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        ],
        title: {
          text: '回收量', // 标题文本
          subtext: this.result || 0, // 副标题文本
          top: initTitlePosition.top, // 距离顶部10%
          left: initTitlePosition.left, // 水平居中
          textAlign: 'center', // 文本对齐方式
          textStyle: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 1)',
          },
          subtextStyle: {
            fontSize: 18,
            color: 'rgba(255, 255, 255, 1)',
          },
          borderColor: '#033045', // 边框颜色
          borderWidth: 10, // 边框宽度
          borderRadius: 65, // 边框圆角
          padding: 30, // 内边距
        },
        tooltip: {
          trigger: 'item',
          padding: 0,
          formatter: function (parmars) {
            let DOM1 = `<div style="width: auto;line-height: 25px;color: black;font-weight:500;padding: 10px;background: linear-gradient(345deg, ${parmars.color.colorStops[0].color} 0%, ${parmars.color.colorStops[1].color} 100%)">
                        <span style="font-weight: 400">${parmars.name}：</span><span>${parmars.value}</span> / <span>${parmars.percent}%</span>
                        </div>`;
            return DOM1;
          },
          position: function (pos, params, dom, rect, size) {
            // 计算四个可能的位置
            const positions = {
              top: [
                pos[0] - size.contentSize[0] / 2,
                pos[1] - size.contentSize[1] - 10,
              ],
              bottom: [pos[0] - size.contentSize[0] / 2, pos[1] + 20],
              left: [
                pos[0] - size.contentSize[0] - 15,
                pos[1] - size.contentSize[1] / 2,
              ],
              right: [pos[0] + 15, pos[1] - size.contentSize[1] / 2],
            };

            // 找出完全在可视区域内的位置
            for (const [key, [x, y]] of Object.entries(positions)) {
              if (
                x >= 10 &&
                x + size.contentSize[0] <= rect.width - 10 &&
                y >= 10 &&
                y + size.contentSize[1] <= rect.height - 10
              ) {
                return [x, y];
              }
            }

            // 默认返回顶部位置（即使部分超出）
            return positions.top;
          },
        },
        // 在initEcharts方法的option配置中，将原来的legend配置替换为以下内容
        legend: [
          // 左侧图例
          {
            orient: 'vertical',
            top: 'center',
            left: '5%', // 左侧距离
            data: this.Data.slice(0, Math.ceil(this.Data.length / 2)), // 取前半部分数据
            textStyle: {
              color: '#fff',
              fontSize: 12,
              overflow: 'truncate',

              width: 80,
              ellipsis: '...',
            },
            itemGap: 10,
            tooltip: {
              show: true,
              formatter: function (parmars) {
                console.log(parmars, 'parmars', that.Data);
                let name;
                let Index
                that.Data.forEach((item,index) => {
                  if (item.name === parmars.name) {
                    if(index>9){
                      Index = (index+1) % 10
                    }else {
                      Index = index
                    }
                    console.log(Index,index,'index')
                    name =  `<div style="width: auto;line-height: 15px;color: black;font-weight:500;padding: 5px;background: linear-gradient(345deg, ${that.color[Index].colorStops[0].color} 0%, ${that.color[Index].colorStops[1].color} 100%)">
                        <span style="font-weight: 400">${parmars.name}：</span><span>${item.value}</span> / <span>${item.percentage}</span>
                        </div>`
                  }
                });
                return name;
              },
            },
            // 图例文字截断处理
            formatter: (name) => truncateText(name),
          },
          // 右侧图例
          {
            orient: 'vertical',
            top: 'center',
            right: '5%', // 右侧距离
            data: this.Data.slice(Math.ceil(this.Data.length / 2)), // 取后半部分数据
            textStyle: {
              color: '#fff',
              fontSize: 12,
              overflow: 'truncate',
              width: 80,
              ellipsis: '...',
            },
            itemGap: 10,
            tooltip: {
              show: true,
              formatter: function (parmars) {
                console.log(parmars, 'parmars', that.Data);
                let name;
                let Index
                that.Data.forEach((item,index) => {
                  if (item.name === parmars.name) {
                    if(index>9){
                      Index = index % 10
                    }else {
                      Index = index
                    }
                    console.log(Index,index,'index')
                    name =  `<div style="width: auto;line-height: 15px;color: black;font-weight:500;padding: 5px;background: linear-gradient(345deg, ${that.color[Index].colorStops[0].color} 0%, ${that.color[Index].colorStops[1].color} 100%)">
                        <span style="font-weight: 400">${parmars.name}：</span><span>${item.value}</span> / <span>${item.percentage}</span>
                        </div>`
                  }
                });
                return name;
              },
            },
            // 图例文字截断处理
            formatter: (name) => truncateText(name),
          },
        ],
        grid: {
          top: 50,
          left: 50,
          right: 50,
          bottom: 50,
          containLabel: true,
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['65%', '80%'],
            center: ['50%', '50%'],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
              length: 30,
            },
            data: this.Data,
          },
        ],
      };
      this.myChart.setOption(option);
      autoToolTip(this.myChart, option, {
        // 轮播间隔时间 默认2s
        interval: 2000,
        // 是否循环轮播所有序列
        loopSeries: false,
        // 第1个被轮播的序列下标
        seriesIndex: 0,
      });
    },
    // 新增数据过滤以及数据排序
    processWasteData(data) {
      // 1. 过滤出unit为"万吨"的数据
      const filtered = data.filter((item) => item.unit === '万吨');

      // 2. 将amount转换为数值并按从大到小排序
      const sorted = filtered.sort((a, b) => {
        const amountA = Number(a.amount);
        const amountB = Number(b.amount);
        return amountB - amountA; // 降序排序
      });

      // 3. 若长度超过8，整合下标7以后的数据为"其他"
      if (sorted.length > 9) {
        // 取前8条数据
        const firstSeven = sorted.slice(0, 9);
        // 计算剩余数据的amount总和
        const remaining = sorted.slice(9);
        const total = remaining.reduce((sum, item) => {
          return sum + Number(item.amount);
        }, 0);
        // 添加"其他"分类
        firstSeven.push({
          name: '其他',
          amount: total.toString(),
          unit: '万吨',
          type: 'other',
          icon: '', // 可根据实际需求设置默认图标
        });
        return firstSeven;
      }

      // 长度不超过8时直接返回排序后的数据
      return sorted;
    },
  },
};
</script>

<style lang="less" scoped>
.recyLing {
  width: 100%;
  height: 100%;
  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
